import React from 'react'

import Header from './Header/Header'
import Sidebar from './Sidebar/Sidebar'
import Footer from './Footer'
import AdvertiseButton from './advertiseButton'
import Banner from './Banner'
import { Outlet } from 'react-router-dom'

const MainLayout = () => {
  return (
    <React.Fragment>
      <div id='layout-wrapper'>
        <Header />
        <Sidebar />
        <Banner />
        <div className='main-content'>
          <div className='content'>
            <Outlet />
          </div>
        </div>
        {/* <AdvertiseButton /> */}
        <Footer />
      </div>
    </React.Fragment>
  )
}

export default MainLayout
